var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tbl-sort link",on:{"click":_vm.sort}},[_vm._t("default"),(_vm.state)?_c('i',{class:'sort-icon zmdi zmdi-triangle-' + _vm.state}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }